// Same directory as the Proxy launch form, including its custom XA entry.
const countryCodes = `AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS XA YE YT ZA ZM ZW`.split(" ");

export function triproutesCountries(site) {
  const locale = site === "app" ? "en-US" : "ru-RU";
  const names = new Intl.DisplayNames([locale], { type: "region" });
  return [...new Set(countryCodes)].map((code) => ({ code, name: code === "XA" ? (site === "app" ? "Abkhazia" : "Абхазия") : names.of(code) || code }))
    .sort((a, b) => a.name.localeCompare(b.name, locale));
}

export function triproutesCityReadinessURL(site, draft = {}) {
  const query = new URLSearchParams({site:site === "app" ? "app" : "ru"});
  for (const flag of ["skipCityResearch","skipCityContent","skipAgent4"]) query.set(flag,String(Boolean(draft[flag])));
  return `/v1/triproutes/city-routes/readiness?${query}`;
}

export function triproutesLaunchBody(draft, site) {
  const country = triproutesCountries(site).find((item) => item.code === draft.countryCode);
  if (!country) throw new Error("Выберите страну из справочника.");
  const urls = (draft.researchURLs || "").split(/\r?\n/).map((item) => item.trim()).filter(Boolean);
  if (urls.length > 10) throw new Error("Для Агента 0 можно добавить не более 10 ссылок.");
  for (const raw of urls) {
    let url;
    try { url = new URL(raw); } catch { throw new Error("Укажите полные ссылки, начинающиеся с https:// или http://."); }
    if (!["https:", "http:"].includes(url.protocol) || !url.hostname || url.username || url.password || raw.length > 2000) {
      throw new Error("Укажите полные ссылки без логина и пароля, не длиннее 2000 символов.");
    }
  }
  const notes = (draft.researchNotes || "").trim();
  if ([...notes].length > 4000) throw new Error("Темы и заметки должны быть не длиннее 4000 символов.");
  return {
    site, cityName: draft.cityName, country: country.name, countryCode: country.code,
    candidateLimit: Number(draft.candidateLimit), requestedRouteCount: Number(draft.requestedRouteCount),
    skipCityResearch: !!draft.skipCityResearch, skipAgent4: !!draft.skipAgent4, skipCityContent: !!draft.skipCityContent,
    researchHints: { urls: [...new Set(urls)], notes },
  };
}
